import { render, staticRenderFns } from "./OppregWorkloadStep2.vue?vue&type=template&id=2edc2eb1&scoped=true&"
import script from "./OppregWorkloadStep2.vue?vue&type=script&lang=js&"
export * from "./OppregWorkloadStep2.vue?vue&type=script&lang=js&"
import style0 from "./OppregWorkloadStep2.vue?vue&type=style&index=0&id=2edc2eb1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2edc2eb1",
  null
  
)

export default component.exports